import React from 'react';

import { motion } from 'framer-motion';
import WhatYouLearn from '../components/home/WhatYouLearn';
import Hero from "../components/home/Hero";
import FeaturedProducts from '../components/home/FeaturedProducts';
import ChatBot from '../components/home/ChatBot';
import WhatsAppButton from "../pages/WhatsAppButton";
import OnlyCollage from '../components/home/OnlyCollage';
import CourseContent from '../components/home/CourseContent';
import About from './About';
import AboutLuNahu from "../components/home/AboutLuNahu";
import HeroLuCuadros from "../components/home/HeroLuCuadros";
import CoursePriceInfo from '../components/home/CoursePriceLu';
import Overview from '../components/home/Overview';
import SubirCuadro from './Cuadros';
import GaleriaCuadros from './GaleriaCuadros';
const containerVariants = {
  hidden: {
    opacity: 0 
  },
  visible: {
    opacity: 1,
    transition: { duration: .3 }
  },
  exit: {
    x: '-100vw',
    transition: { ease: 'easeInOut' }
  }
}


const Home = () => {
  return (
    <motion.main
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >

<HeroLuCuadros/>
  

<Overview/>
      <WhatsAppButton/>
  <OnlyCollage/>
    </motion.main>
  );
};

export default Home;